import { render, staticRenderFns } from "./SchemaField.vue?vue&type=template&id=5541098e&scoped=true"
import script from "./SchemaField.vue?vue&type=script&lang=js"
export * from "./SchemaField.vue?vue&type=script&lang=js"
import style0 from "./SchemaField.vue?vue&type=style&index=0&id=5541098e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5541098e",
  null
  
)

export default component.exports